import { selector, atom } from "recoil";
import { blogs, blogItems, imgGal } from "../services/apiCalls";

export const editBlogBal = atom({
  key: "editBlogBal",
  default: {}
})

export const createBlogID = atom({
  key: "creatBlogID",
  default: {}
})

export const blogId = atom({
  key: "blogId",
  default: ""
})

export const createBlogModal = atom({
  key: "createBlogModal",
  default: false
})

export const editBlogModal = atom({
  key: "editBlogModal",
  default: false
})

export const blogAlert = atom({
  key: "blogAlert",
  default: false
})

export const blogResponse = atom({
  key: "blogResponse",
  default: {}
})

export const blogRefresh = atom({
  key: "blogRefresh",
  default: ""
})

export const blogEditor = atom({
  key: "blogEditor",
  default: ""
})

export const gallery = selector({
  key: "gallery",
  get: async ({ get }) => {
    try {
      const res = get(blogRefresh);
      console.log(res)
      const result = await imgGal("merchant");
      return result.data || {};
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return {};
    }
  }
});

export const blogList = selector({
  key: "blogList",
  get: async ({ get }) => {
    try {
      const res = get(blogRefresh);
      console.log(res)
      const result = await blogs();
      return result.data || {};
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return {};
    }
  }
});

export const blogItem = selector({
  key: "blogItem",
  id:{},
  get: async ({ get }) => {
    try {
      const id = get(blogId)
      const res = get(blogRefresh);
      console.log(res)
      const result = await blogItems(id);
      return result.data || {};
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return {};
    }
  }
});